<div class="my-quotes-table">
    <div class="my-quotes-table--search-filter">
        <div class="my-quotes-table--search">
            <form class="search-wrapper">
                <input [placeholder]="state.sectionMiddle.search.placeholder" class="search-fields"
                    (keydown.enter)="$event.preventDefault()" (keyup)="applySearch()" maxlength="50" aria-label="search"
                    name="search" type="text" [ngClass]="{'search-fields--form-input-error': isInvalidLength}"
                    [(ngModel)]="service.searchData" autocomplete="off" tabindex="0" />
                <button class="clear" [ngClass]="{'clear--input-error': isInvalidLength}" (click)="getOriginalData()"
                    aria-label="clear button" [tabindex]="-1" role="button">
                    <span tabindex="0" aria-label="clear button">&times;</span>
                </button>
            </form>
            <div class="search-form-error" *ngIf="isInvalidLength" role="alert" tabindex="0">
                {{ state.sectionMiddle.search.invalidSearchText }}
            </div>
        </div>
        <div class="d-flex w-100">
            <div class="my-quotes-table-filter" tabindex="0" (keypress)="openFilter()">
                <button class="btn my-quotes-table-filter--filter-btn" aria-label="My Quotes Filter"
                    (click)="openFilter()">
                    <img src="{{ state.sectionMiddle.filteringPanelSection.filterIcon }}" alt="Filter icon" />
                    <span class="filterHeading">{{ state.sectionMiddle.filteringPanelSection.filterLabel }}
                        <span *ngIf="selectedFilterObj.length !== 0">
                            ({{selectedFilterObj.length}})
                        </span>
                    </span>
                </button>
                <kng-filter-panel #myQuotesFilterComponent [state]="filterState" (stateChanged)="filterStateChanged()"
                    (filterApplied)="filterApplied($event)" (getCountOfFilterPanel)="getCountOfFilterPanel($event)"
                    (closeFilterEvent)="closeFilter()">
                </kng-filter-panel>
            </div>
            
            <div class="downloadButton" *ngIf="isRaymond">
                <div class="button-download d-flex align-items-center" (click)="downloadMyQuotesTableData()" *ngIf="!this.state.sectionMiddle.download.disabled; else loading">
                  <img [src]="icons.downloadButtonIconRaymond" alt="download-icon" class="download-icon" /> 
                  <span class="download-text">{{ downloadNote.en }}</span> 
                </div>
                <ng-template #loading>
                    <img class="downloadBtn" [src]="icons.raymondDownloadLoader" [alt]="downloadNote.en" /> {{ downloadNote.en }}
                  </ng-template>
            </div>
            
            <div class="downloadButton" *ngIf="!isRaymond">
                <div class="button-download" (click)="downloadMyQuotesTableData()" *ngIf="!this.state.sectionMiddle.download.disabled; else loading">
                  <img [src]="icons.downloadData" alt="download icon" class="download-icon" /> &nbsp; <u>{{state.sectionMiddle.download.label}}</u>
                </div>
                <ng-template #loading>
                  <img width="50px" [src]="icons.loaderWithoutForklift" [alt]="downloadNote.en" /> {{ downloadNote.en }}
                </ng-template>
            </div>
        </div>
    </div>
    <div class="my-quotes-table--selectedFilters">
        <span class="selectedFilter">{{ state.sectionMiddle.filteringPanelSection.selectedFilterLabel}}:</span>
        <mat-form-field>
            <mat-chip-list class="matChipList" #chipList aria-label="Filter selection" [tabIndex]="-1">
                <mat-chip disabled class="selectedFilterChip" *ngFor="let filter of selectedFilterObj" [tabIndex]="0">
                    <button class="iconClose" (click)="removeFilter(filter)"
                        [ngClass]="{ 'defaultFilter': filter.disabled === true }">
                        <img src="/assets/close.svg" alt="close icon" class="icon" />
                    </button>
                    {{ filter.key !== billingAddressKey ? filter.value : filter.value | truncate: 21 }}
                </mat-chip>
                <button class="btn clearAll" (click)="removeAllFilter()" tabindex="0"
                    [ngClass]="{ 'defaultFilter': defaultFilter === true }">
                    {{ filterState.filterData.ctaList[0].label }}
                </button>
            </mat-chip-list>
        </mat-form-field>
    </div>
    <hr class="mobile" />
    <div class="row m-0"
        *ngIf="service.invoiceStatusCount.count.length > 0 && state.sectionMiddle.invoiceStatusUpdated">
        <div class="col-sm-12 status-select">
            <kng-status-selector [state]="service.invoiceStatusCount" (selectionChanged)="applyStatusFilterToCount($event)"></kng-status-selector>
        </div>
    </div>
</div>
<div class="row m-0 p-0 ">
    <div class="col-12 p-0 myQuoteTable">
      <div *ngIf="cardState; else elseTemplate" >
        <kng-card-list
          [state]="cardState"
          (pageIndex)="pageChanged($event)"
          (sortColumnEvent)="checkSortEvent($event)"
          (linkToQuotesPDF)="downloadQuotePdf($event)"
          [resetPage]="resetPage"
      ></kng-card-list>
      </div>
      <ng-template #elseTemplate> Loading... </ng-template>
    </div>
</div>
